import React from "react";
import Faq from "./Sub/FaqCard";
import faqs from "../../../assets/data/faqs";

const Faqs = () => {
  return (
    <section className="md:py-94px py-64px">
      <div className="max-w-[800px] md:px-30px m-auto px-20px">
        <div>
          <h1 className="text-xl font-medium mb-10px text-accent-900 dark:text-accent-100">
            <span className="font-bold text-2xl ">FAQ - </span>
            Frequently Asked Questions
          </h1>
          <h6 className="text-base text-accent-400 dark:text-accent-300 font-light mb-25px">
            For more questions{" "}
            <a
              className="text-accent-400 font-medium"
              href="mailto:jadamohameed@gmail.com"
              target="blank"
            >
              jadamohameed@gmail.com
            </a>
          </h6>
        </div>
        <div className="flex flex-col md:gap-32px gap-20px">
          {faqs.map((faq, index) => (
            <Faq
              index={index}
              key={faq.question}
              question={faq.question}
              answer={faq.answer}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faqs;
